import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FCDATEMODE } from './fcdate.component';
import { FcinputComponent } from '../fcinput';
import { CommonService } from 'fccore2';
/**
 * fc-datetimeæ¥ææ¶é´
 * 
 * è¾å¥æéæ©æ¥ææ¶é´çæ§ä»¶ã
 * 
 * å½ç¨æ·éè¦è¾å¥ä¸ä¸ªæ¥ææ¶é´æ¶ï¼å¯ä»¥ç¹å»æ åè¾å¥æ¡ï¼å¼¹åºæ¥ææ¶é´é¢æ¿è¿è¡éæ©ã
 * 
 */
@Component({
    selector: 'fc-datetime',
    template: `
    <nz-date-picker *ngIf="fcShowLabel==='N'" [nzAllowClear]="fcAllowClear==='Y'" [ngClass]="{'fc-readonly':_readonly===true,'fc-datetime-small':fcSize === 'small','fc-datetime-default':fcSize === 'default','fc-datetime-large':fcSize === 'large'}" 
    nzShowTime [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" 
    [nzDisabledDate]="_disabledDate" [nzMode]="fcMode" [nzPlaceHolder]="fcPlaceHolder" 
    [nzFormat]="fcFormat" [nzSize]="fcSize" [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-date-picker>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-date-picker style="width:100%;" [nzAllowClear]="fcAllowClear==='Y'" [ngClass]="{'fc-readonly':_readonly===true,'fc-datetime-small':fcSize === 'small','fc-datetime-default':fcSize === 'default','fc-datetime-large':fcSize === 'large'}" nzShowTime [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabledDate]="_disabledDate" [nzMode]="fcMode" 
                    [nzPlaceHolder]="fcPlaceHolder" [nzFormat]="fcFormat" [nzSize]="fcSize" [nzDisabled]="_disabled"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" ></nz-date-picker>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
               
    `,
    styles: [`
    .fc-readonly {
        pointer-events: none;
    }
    :host ::ng-deep .fc-readonly .ant-input{
        background-color: #f5f5f5;
    }
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    `
    ],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcdatetimeComponent),
        multi: true
    }]
})
export class FcdatetimeComponent extends FcinputComponent {

    @Input()
    fcAllowClear: String;
    /**æå¤©ä¹å*/
    @Input()
    fcBefore: string;
    /**æå¤©ä¹å*/
    @Input()
    fcAfter: string;
    /**æ¨¡å¼:éæ©å°å¤©ä¸ºdayï¼éæ©å°æä¸ºmonthï¼*/
    fcMode: string = FCDATEMODE.day;
    /**æ¥ææ ¼å¼ é»è®¤YYYY-MM-DD HH:mm:ssï¼YYYY/MM/DD HH:mm:ssï¼YYYYå¹´MMæDDæ¥ HH:mm:ssï¼æ¶*/
    @Input()
    fcFormat: string;
    /**è¾å¥æç¤ºç¬¦*/
    @Input()
    fcPlaceHolder: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-datetime');
        this._innerValue = null;
        if (this.fcFormat === undefined) {
            this.fcFormat = 'yyyy-MM-dd HH:mm:ss';
        }
        if (this.fcPlaceHolder === undefined) {
            this.fcPlaceHolder = 'éæ©æ¶é´';
        }
    }
    _afterParentInit() {
        /**æ¯å¦ç¦ç¨*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        } else {
            this._disabled = false;
        }
        /**æ¯å¦åªè®*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        } else {
            this._readonly = false;
        }
        if (!this.fcAllowClear) {
            this.fcAllowClear = 'Y';
        }
    }
    /**
     * å½æ°è¯´æï¼å¤§äºæä¸ªæ¶é´çç¦æ­¢éæ©
     */
    _disabledDate = (param: any): boolean => {
        if (this.fcBefore !== undefined) {
            let beforeDate = CommonService.getTimestampFromDate(this.fcBefore.replace(/-/g, "/"));

            return param && param.getTime() > beforeDate * 1000;
        }
        if (this.fcAfter !== undefined) {
            let afterDate = CommonService.getTimestampFromDate(this.fcAfter.replace(/-/g, "/"));
            return param && param.getTime() < afterDate * 1000;
        }
        return false;
    }
}

